import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// 解决导航栏或者底部导航tabBar中的vue-router在3.0版本以上频繁点击菜单报错的问题。
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/LoginNew.vue')
  },
  {
    path: '/',
    name: 'Manager',
    component: () => import('../views/Manager.vue'),
    redirect: '/home',  // 重定向到主页
    meta: { requiresAuth: true }, // 需要登录才能访问
    children: [
      {
        path: 'home',
        name: 'Home',
        meta: { name: '系统首页' },
        component: () => import('../views/Home/index.vue')
      },
      {
        path: 'formatTransform',
        name: 'FormatTransform',
        meta: { name: '格式转化' },
        component: () => import('@/views/FormatTransform/index.vue')
      },
      {
        path: 'ppt',
        name: 'Ppt',
        meta: { name: 'AI PPT' },
        component: () => import('@/views/PPT/index.vue')
      },
      {
        path: 'course',
        name: 'Course',
        meta: { name: '微课制作' },
        component: () => import('@/views/Course/index.vue')
      },
    ]
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
        offset: { x: 0, y: 80 } // 调整偏移量以匹配导航栏高度
      };
    }
    // 导航栏 query 跳转
    if (to.query && to.query.type) {
      return {
        selector: `#${to.query.type}`,
        behavior: 'smooth',
        offset: { x: 0, y: 80 }
      };
    }
    if (to.query && to.query.id) {
      return {
        selector: `#${to.query.id}`,
        behavior: 'smooth',
        offset: { x: 0, y: 80 }
      };
    }
    return { x: 0, y: 0 };
  }
});

// 添加路由守卫
router.beforeEach((to, from, next) => {
  // 检查是否需要认证
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // 检查是否已登录
    const token = localStorage.getItem('token');
    if (!token) {
      // 如果未登录，重定向到登录页
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    } else {
      // 已登录，继续导航
      next();
    }
  } else {
    // 不需要认证的页面，直接访问
    next();
  }
});

export default router
